<template>
  <div class="login">
    <div style="width:100%;text-align:center">
    <!--logo-->
    <div style="text-align:center;margin-top:140px;margin-bottom:20px;width:100%">
      <img :src="logoUrl" style="max-width:300px;max-height:180px" />
    </div>
    <!--登录组件-->
    <div class="main-box" style="padding-top: 1px;">
      <h1 style="margin:10px">{{billCompany}}</h1>
      <div class="main-login">
        <!-- 用户登录 -->
        <div class="userLogin">
          <el-form
            :model="ruleForm"
            status-icon
            :rules="rules"
            ref="ruleForm"
            label-width="100px"
            class="demo-ruleForm"
          >
            <!-- 账号 -->
            <el-form-item prop="tel">
              <el-input
                size="medium"
                type="text"
                v-model.trim="ruleForm.tel"
                prefix-icon="el-icon-user-solid"
                autocomplete="off"
                placeholder="请输入客户代码"
              ></el-input>
            </el-form-item>
            <!-- 密码 -->
            <el-form-item prop="pass">
              <el-input
                type="password"
                size="medium"
                v-model.trim="ruleForm.pass"
                prefix-icon="el-icon-s-goods"
                autocomplete="off"
                placeholder="密码"
              ></el-input>
            </el-form-item>
            <!-- 登录按钮 -->
            <el-form-item class="form-item">
              <el-button type="primary" @click="submitLogin('ruleForm')" size="medium">登录</el-button>
            </el-form-item>
            <!-- 注册 -->
            <div class="registered">
                <el-tooltip class="item" effect="dark" content="请联系系统管理员或业务" placement="top-start">
                    <div class="registered_left">无法登录？</div>
                </el-tooltip>
                <el-link
                  type="primary"
                  :underline="false"
                  @click="wxLoginDialog"
                  class="registered_r">
                  微信登录
                </el-link>
            </div>
          </el-form>
        </div>
        <el-dialog
          :visible.sync="msgDialogVisible"
          :close-on-click-modal="false"
          width="342px"
          :modal-append-to-body = "false">
          <Wxlogin
            id="wxLoginForm"
            :appid="appid"
            :scope="scope"
            :redirect_uri="redirect_uri"
          ></Wxlogin>
        </el-dialog>
        <!-- 短信验证 -->
      </div>
    </div>
    <!--备案号显示（居底）-->
    <div style="position: absolute;bottom: 10px;width: 100%;color:#FFF;font-size: 16px;">
      {{record}}
    </div>
    </div>
  </div>
</template>
<script>
//引入api
import httpApi from "@/http/api";

import Wxlogin from "vue-wxlogin"
export default {
  components: {
    Wxlogin // 声明引用组件
  },
  data() {
    //正则账号验证
    var validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入账号"));
      } else {
        callback();
      }
    };
    //正则密码验证
    var validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入密码"));
      } else {
        callback();
      }
    };
    return {
      appid: "", // 应用唯一标识，在微信开放平台提交应用审核通过后获得
      scope: "snsapi_login", // 应用授权作用域，网页应用目前仅填写snsapi_login即可
      redirect_uri: "", // 重定向地址 （回调地址）
      msgDialogVisible: false,
      logoUrl: "",
      billCompany: "",
      record: "",
      ruleForm: {
        //账号
        tel: "",
        //密码
        pass: ""
      },
      //正则
      rules: {
        tel: [{ validator: validatePass, trigger: "blur" }],
        pass: [{ validator: validatePass2, trigger: "blur" }]
      },
      code:""
    };
  },
  methods: {
    //获取登录页log
    init(){
      let that = this;
      httpApi
        .listParams({
          params: {
            type: "sys_config",
            enable: "1",
          },
        })
        .then((res) => {
          if (res.data.code == "ok") {
            that.logoUrl = res.data.data[0].logoPortalUrl;
            that.billCompany = res.data.data[0].title;
            that.record = res.data.data[0].record;
          }
        });
    },
    initWeixin(){
      let that = this;
      httpApi
        .listParams({
          params: {
            type: "sys_weixin",
            enable: "1",
          },
        })
        .then((res) => {
          if (res.data.code == "ok") {
            that.redirect_uri = encodeURI("http://"+res.data.data[0].encodeUrl+"/login");
            that.appid = res.data.data[0].appid;
          }
        });
    },
    submitLogin(formName) {
      let that = this;
      that.$refs[formName].validate(valid => {
        if (valid) {
          //登录
          httpApi
            .submitLogin({
              account: that.ruleForm.tel,
              password: that.ruleForm.pass
            })
            .then(res => {
              if (res.data.code == "ok") {
                //令牌存储到临时缓存
                sessionStorage.setItem("token", res.data.data.token);
                // localStorage.setItem("refToken", res.data.data.refreshToken);
                //登录成功
                // that.$message.success("登录成功！");
                //跳转首页
                that.$router.push("/");
              } else {
                that.$message.error(res.data.message);
              }
            });
        } else {
          return false;
        }
      });
    },
    fastLogin() {
      let that = this;
      if(this.code==undefined){
        var url = document.location.toString(); //获取url地址
        var urlParmStr = url.slice(url.indexOf("=") + 1); //获取问号后所有的字符串
        if (url.indexOf("?") !== -1) {
          httpApi.fastLogin({ token: urlParmStr }).then(res => {
            if (res.data.code == "ok") {
              //令牌存储到临时缓存
              sessionStorage.setItem("token", res.data.data.token);
              localStorage.setItem("refToken", res.data.data.refreshToken);
              //登录成功
              // that.$message.success("登录成功！");
              //跳转首页
              that.$router.push("/");
            } else {
              that.$message.error("自动登录失效！");
              return false; //中断自动登录
            }
          });
        }
        httpApi
                .listParams({//api地址记得变更
                  params: {
                    type: "sys_config",
                    enable:"1"
                  }
                })
                .then(ress => {
                  if (ress.data.code == "ok") {
                    sessionStorage.setItem("ico",  ress.data.data[0].ico);
                    sessionStorage.setItem("title",  ress.data.data[0].title);
                    let ico = sessionStorage.getItem('ico');
                    let link = document.querySelector("link[rel*='icon']") || document.createElement('link');
                    link.type = 'image/x-icon';
                    link.rel = 'shortcut icon';
                    link.href = ico
                    document.getElementsByTagName('head')[0].appendChild(link);
                  }else{
                    that.$message.error(ress.data.message);
                  }
                });
      }
    },
    wxLoginDialog() {
      this.msgDialogVisible = true;
    },
    wxLogin() {
      if(this.code!=null&&this.code!=undefined&&this.code!=""){
        //登录
        httpApi
          .wxLogin({
            params:{
              code: this.code
            }
          })
          .then(res => {
            if (res.data.code == "ok") {
              //令牌存储到临时缓存
              sessionStorage.setItem("token", res.data.data.token);
              // localStorage.setItem("refToken", res.data.data.refreshToken);
              //登录成功
              // that.$message.success("登录成功！");
              //跳转首页
              this.$router.push("/");
            } else {
              this.$message.error(res.data.message);
            }
          });
      }
    }
  },
  created() {
    this.code = this.$route.query.code;
    this.wxLogin();
    this.fastLogin();
    this.init();
    this.initWeixin();

    //回车键直接登录
    let that = this;
    document.onkeypress = function(e) {
      var keycode = document.all ? event.keyCode : e.which;
      //需要注意的：that.$route.path==''/login'的作用是如果不判断，回车可能所有页面都生效，也就是无论在哪个页面敲回车都会直接登录
      if (that.$route.path == "/login" && keycode == 13) {
        that.submitLogin("ruleForm");
        return false;   
      }
    };
  }
};
</script>
<style lang="less" scoped>
.login {
  width: 100%;
  height: 100%;
  position: fixed;
  display: flex;
  background: url("../assets/beijing.png") no-repeat;
  background-attachment:fixed;
  background-size:cover;
  background-position:center;
  background-repeat:no-repeat;
  .main-box {
    border-radius: 10px;
    width: 500px;
    height: auto;
    margin: auto;
    background: #ffffff;
    border: #888 0px solid;
    filter: progid:DXImageTransform.Microsoft.Shadow(color=#888, strength=4);
    -moz-box-shadow: 0 0 50px #888;
    -webkit-box-shadow: 0 0 50px #888;
    box-shadow: 0 0 25px #888;
    h1 {
      margin-top: 20px;
      text-align: center;
      font-size: 22px;
    }
    .main-login {
      margin: 40px;
      //用户登录
      .userLogin {
        font-size: 14px;
        /deep/.el-form-item__content {
          margin: 0 20px !important;
        }
        .el-button {
          width: 100% !important;
          margin: 0 !important;
        }
        /deep/.form-item {
          margin: 10px 0px;
        }
        .CLogin {
          width: 100%;
          height: 40px;
          line-height: 40px;
          .CLogin_left {
            float: left;
            margin-left: 20px;
            cursor: pointer;
          }
          .CLogin_r {
            float: right;
            margin-right: 20px;
            cursor: pointer;
          }
        }
        .registered {
          width: 100%;
          height: 40px;
          line-height: 40px;
          color: #72b3e6;
          .registered_left {
            float: left;
            margin-left: 20px;
            cursor: pointer;
          }
          .registered_r {
            float: right;
            margin-right: 20px;
            cursor: pointer;
          }
        }
      }
    }
  }
}
</style>
